var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardMember(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8188_131131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8068 13.375C19.3636 14.4318 20.4546 15.8636 20.4546 17.7727V21.1818H23.8636C24.4886 21.1818 25 20.6704 25 20.0454V17.7727C25 15.2954 20.9432 13.8295 17.8068 13.375Z",
    fill: "#F29500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09089 12.0909C11.6013 12.0909 13.6363 10.0558 13.6363 7.54545C13.6363 5.03507 11.6013 3 9.09089 3C6.58051 3 4.54545 5.03507 4.54545 7.54545C4.54545 10.0558 6.58051 12.0909 9.09089 12.0909Z",
    fill: "#F29500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9091 12.0909C18.4205 12.0909 20.4546 10.0568 20.4546 7.54545C20.4546 5.03409 18.4205 3 15.9091 3C15.375 3 14.875 3.11364 14.3977 3.27273C15.3409 4.44318 15.9091 5.93181 15.9091 7.54545C15.9091 9.15908 15.3409 10.6477 14.3977 11.8182C14.875 11.9773 15.375 12.0909 15.9091 12.0909Z",
    fill: "#F29500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09089 13.2273C6.05681 13.2273 0 14.75 0 17.7727V20.0454C0 20.6704 0.511363 21.1818 1.13636 21.1818H17.0454C17.6704 21.1818 18.1818 20.6704 18.1818 20.0454V17.7727C18.1818 14.75 12.125 13.2273 9.09089 13.2273Z",
    fill: "#F29500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8188_131131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMember);
export default __webpack_public_path__ + "static/media/dashboard_member.84dff9a63c9185aa747e00de81591bc3.svg";
export { ForwardRef as ReactComponent };